import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import "./UpdatePasswordModal.css";
import CustomModal from "../CustomModal/CustomModal";
import ModalFooter from "../CustomModal/ModalFooter";
import ModalHeader from "../CustomModal/ModalHeader";
import CustomTextField from "../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import toast from "react-hot-toast";
import Compdirection from "../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: any) => void;
  trans?: any;
}

const UpdatePasswordModalPresenter = ({
  isModalOpen,
  closeModal,
  trans,
  callBackHandleClockIn,
}: ModalProps) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showReTpPassword, setShowRetpPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [reTypeNewPassword, setReTypeNewPassword] = useState("");

  const handleToggleNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleToggleReTpPassword = () => {
    setShowRetpPassword(!showReTpPassword);
  };


  const handleSubmit = () => {
    if (currentPassword && newPassword && reTypeNewPassword){
      if(currentPassword === newPassword){
        toast.error(trans("Current Password and New Password cannot be the same."));
      }
      else if (newPassword !== reTypeNewPassword) {
        toast.error(trans("New Password and Confirm Password do not match."));
      } else {
        callBackHandleClockIn({
          password: currentPassword,
          newPassword: newPassword,
          confirmPassword: reTypeNewPassword,
        });
        closeModal();
      }
    } else {
      toast.error(trans("Please Enter Valid Data!"));
    }

  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="354px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Change Password") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "35px",
          }}
        >
          <Grid item xs={12}>
            <CustomTextField
              // type="password"
              type={showPassword ? 'text' : 'password'}
              label={trans("Current Password")}
              placeholder={trans("Write Current Password")}
              value={currentPassword}
              onChange={(e: any) => setCurrentPassword(e.target.value.replace(/\s/g, ''))}
              InputProps={
                {
                  endAdornment: (
                      <i className={showPassword ? "las la-eye-slash" : "las la-eye"}  onClick={handleTogglePassword} style={{cursor: "pointer"}}/>
                  ),
                }
              }
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              // type="password"
              type={showNewPassword ? 'text' : 'password'}
              label={trans("New Password")}
              placeholder={trans("Write New Password")}
              value={newPassword}
              onChange={(e: any) => setNewPassword(e.target.value.replace(/\s/g, ''))}
              InputProps={
                {
                  endAdornment: (
                      <i className={showNewPassword ? "las la-eye-slash" : "las la-eye"}  onClick={handleToggleNewPassword} style={{cursor: "pointer"}}/>
                  ),
                }
              }
            />
            
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type={showReTpPassword ? 'text' : 'password'}
              label={trans("Re-Type New Password")}
              placeholder={trans("Re-Type New Password")}
              value={reTypeNewPassword}
              onChange={(e: any) => setReTypeNewPassword(e.target.value.replace(/\s/g, ''))}
              InputProps={
                {
                  endAdornment: (
                      <i className={showReTpPassword ? "las la-eye-slash" : "las la-eye"}  onClick={handleToggleReTpPassword} style={{cursor: "pointer"}}/>
                  ),
                }
              }
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default UpdatePasswordModalPresenter;
